<!-- 验收表单 -->
<template>
    <layui-collapse ref="collapse" class="requestForm">
        <div class="layui-colla-item">
            <h2 class="layui-colla-title">协商处理结果</h2>
          <div class="layui-colla-content layui-show">
            <div class="layui-form-item-one">
              <div class="layui-form-item">
                <label class="layui-form-label">客户诉求描述：</label>
                <div class="layui-input-inline" style="width:32%">
                  {{editRow.CUSTOMER_APPEAL_DESCRIPTION}}
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">争议处理方法：</label>
                <div class="layui-input-inline" style="width:32%">
                  {{editRow.DISPUTE_HANDLING_METHOD}}
                </div>
              </div>
            </div>
          </div>
        </div>
    </layui-collapse>
</template>
<script>
    export default {
        props: {
            editRow: {
                default: () => ({}),
                type: Object
            },
            enabled: {
                type: Boolean,
                default: false,
            }
        },
        data () {
            return {
                editable:false,
            }
        },
        mounted () {
            this.$nextTick(()=> {
                this.editable = this.enabled;
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/workOrder/detailForm/disputeForm.vue